import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${p => p.bg || '#000'};
  padding: 60px 24px;
`;

export const Container = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  color: ${p => p.color || '#fff'};
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 32px;
`;

export const FaqItem = styled.div`
  border: 1px solid ${p => p.$open ? p.accent + '55' : p.accent + '22'};
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 16px 20px;
  cursor: pointer;
  background: ${p => p.$open ? p.accent + '10' : 'transparent'};
  transition: background 0.15s, border-color 0.15s;
  &:hover { border-color: ${p => p.accent}44; }
`;

export const Question = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${p => p.$open ? p.accent : p.color || '#fff'};
  span { font-size: 18px; flex-shrink: 0; margin-left: 12px; }
`;

export const Answer = styled.p`
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.6;
  color: ${p => p.color || '#fff'}99;
`;
